import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './auth-service.interface';
import { AUTH_SERVICE, PUBLIC_FALLBACK_PAGE_URI } from './tokens';

@Injectable({
  providedIn: 'root',
})
export class PublicGuard implements CanActivate, CanActivateChild {
  constructor(
    @Inject(AUTH_SERVICE) private authService: AuthService,
    @Inject(PUBLIC_FALLBACK_PAGE_URI) private publicFallbackPageUri: string,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.authService.isAuthorized().pipe(
      map((isAuthorized) => {
        if (isAuthorized && this.publicFallbackPageUri) {
          return this.router.parseUrl(this.publicFallbackPageUri);
        }

        return !isAuthorized;
      })
    );
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }
}
